"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var configurationTypes_1 = require("../../../shared/types/configurationTypes");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var getColumnEditLayout_1 = __importDefault(require("../../../shared/util/getColumnEditLayout"));
var SwitchComponent_1 = __importDefault(require("../../../shared/components/FormComponents/SwitchComponent"));
var CheckboxComponent_1 = __importDefault(require("../../../shared/components/FormComponents/CheckboxComponent"));
var CrudeBooleanComponent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var entity = props.entity;
    var columnName = props.schema.name;
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var editLayout = react_redux_1.useSelector(crude_selector_1.getEditLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var _h = react_1.useState(props.columnEditLayout || (editLayout && getColumnEditLayout_1.default(entity, columnName || '', editLayout))), columnEditLayout = _h[0], setColumnEditLayout = _h[1];
    react_1.useEffect(function () {
        setColumnEditLayout(props.columnEditLayout);
    }, [props.columnEditLayout]);
    var columnLabels = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[entity]) === null || _b === void 0 ? void 0 : _b.columns;
    var label = (columnLabels && ((_c = columnLabels[columnName]) === null || _c === void 0 ? void 0 : _c.title)) ? (_d = columnLabels[columnName]) === null || _d === void 0 ? void 0 : _d.title : columnName;
    var description = columnLabels && ((_e = columnLabels[columnName]) === null || _e === void 0 ? void 0 : _e.description);
    var disabled = props.disabled ? props.disabled : false;
    var layout = columnEditLayout && columnEditLayout.layout
        ? columnEditLayout.layout
        : (((_f = appLayout.globalInputLayouts) === null || _f === void 0 ? void 0 : _f.boolean) ? (_g = appLayout.globalInputLayouts) === null || _g === void 0 ? void 0 : _g.boolean : configurationTypes_1.BooleanLayout.checkbox);
    var getValue = function () {
        var booleanVal = typeof props.data.data[columnName] === 'boolean' ? props.data.data[columnName] : false;
        return booleanVal;
    };
    var _j = react_1.default.useState(getValue()), value = _j[0], setValue = _j[1];
    var onChangeBoolean = function (checked) {
        setValue(checked);
        var newData = props.data;
        var newColumnData = newData.data;
        newColumnData[columnName] = checked;
        newData.data = newColumnData;
        props.onChange && props.onChange(newData);
    };
    react_1.useEffect(function () {
        setValue(getValue());
    }, [props.data]);
    return (react_1.default.createElement(react_1.default.Fragment, null, (layout === configurationTypes_1.BooleanLayout.switch)
        ? (react_1.default.createElement(SwitchComponent_1.default, { checked: value, onChange: onChangeBoolean, label: label, description: description, disabled: disabled, name: columnName }))
        : (react_1.default.createElement(CheckboxComponent_1.default, { checked: value, onChange: onChangeBoolean, label: label, description: description, disabled: disabled, name: columnName }))));
};
exports.default = CrudeBooleanComponent;
